import { DataGrid, GridColDef, GridClasses } from "@mui/x-data-grid";
import { Box, IconButton, Tooltip } from "@mui/material";
import { AiOutlineFileSearch } from "react-icons/ai";
import { MdOutlineContentCopy } from "react-icons/md";
import { Link } from "react-router-dom";

type RowData = {
  feegroup_id: string;
  name: string;
  description: string;
};

type Props = {
  isLoading: boolean;
  tableData: RowData[];
  page: number;
  pageSize: number;
  rowCount: number;
  setPaginationModel: any;
};

const FeeGroupAgentList = (props: Props) => {
  const { isLoading, tableData, page, pageSize, rowCount, setPaginationModel } = props;

  const NoRowsOverlay = () => {
    if (isLoading) return null;
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>No fee group available</div>;
  };

  const userRole = localStorage.getItem("userRole")?.toLowerCase() || "";

  const handleClickCopy = async (id: string) => {
    try {
      await navigator.clipboard.writeText(id);
    } catch (err) {
      console.error("Failed to copy ID: ", err);
    }
  };

  const customDataGridStyles: Partial<GridClasses> = {
    root: "mui-table-custom",
    columnHeader: "text-start text-md",
    row: "",
  };

  const columns: GridColDef[] = [
    {
      field: "id",
      headerName: "",
      flex: 1,
      minWidth: 50,
      maxWidth: 50,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title="Copy ID" arrow placement="top">
          <div>
            <IconButton
              id={"button-copy-id-" + params?.row?.feegroup_id}
              onClick={() => handleClickCopy(params.row.feegroup_id)}
            >
              <MdOutlineContentCopy className="h-5 w-5 text-navy-700" />
            </IconButton>
          </div>
        </Tooltip>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      sortable: false,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: "Description",
      sortable: false,
      flex: 1,
      minWidth: 300,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      minWidth: 100,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => (
        <Tooltip title="View More Details" arrow placement="right">
          <div className="mr-5">
            <IconButton component={Link} to={`/${userRole}/fee-groups/agent/${params.row.feegroup_id}`}>
              <AiOutlineFileSearch className="h-5 w-5 text-navy-700" />
            </IconButton>
          </div>
        </Tooltip>
      ),
    },
  ];

  return (
    <Box className="card w-full">
      <DataGrid
        sx={{
          "& .MuiDataGrid-cell": {
            padding: "8px 16px",
          },
          "& .MuiDataGrid-columnHeader": {
            padding: "8px 16px",
          },
          "& .MuiTablePagination-input": {
            marginRight: "-20px",
          },
          "& .MuiTablePagination-displayedRows": {
            display: "none",
          },
        }}
        loading={isLoading}
        rows={tableData || []}
        columns={columns}
        getRowId={(row) => row.feegroup_id}
        rowCount={rowCount}
        sortingMode="server"
        paginationMode="server"
        pageSizeOptions={[10, 25, 50, 100]}
        rowHeight={48}
        columnHeaderHeight={48}
        paginationModel={{ page: page, pageSize: pageSize }}
        onPaginationModelChange={(newValue) => setPaginationModel(newValue)}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        classes={customDataGridStyles}
        autoHeight
        slots={{
          noRowsOverlay: NoRowsOverlay,
        }}
      />
    </Box>
  );
};

export default FeeGroupAgentList;
